import type { ColumnDef } from '@tanstack/react-table'
import { TagPill } from '@trellis/roots/tags'
import { Typography } from '@trellis/roots/typography'
import type { TagResponseDto } from '@trellis/shared'

const MAX_VISIBLE_TAGS = 3

export function buildTagsColumn<T extends { tags?: TagResponseDto[] }>(): ColumnDef<T> {
  return {
    id: 'tags',
    header: 'Tags',
    cell: ({ row }) => {
      const tags = row.original.tags ?? []
      const visible = tags.slice(0, MAX_VISIBLE_TAGS)
      const overflow = tags.length - visible.length
      return (
        <div className="flex flex-wrap gap-1">
          {visible.map((tag) => (
            <TagPill
              key={tag.id}
              name={tag.name}
              color={tag.color}
              className="max-w-[100px]"
            />
          ))}
          {overflow > 0 && (
            <Typography variant="label" color="muted">
              +{overflow} more
            </Typography>
          )}
        </div>
      )
    },
  }
}

export function filterGatedColumns<T extends { id: string }>(
  specs: readonly T[],
  isTagsEnabled: boolean,
): T[] {
  return specs.filter((spec) => spec.id !== 'tags' || isTagsEnabled)
}
